import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { BodyAreaServices } from "../../../services";
import { IBaseItem } from "../types";
import { FormattedMessage, useIntl } from "react-intl";

const SelectBodyArea = (props: any) => {
  const [bodyareas, setBodyAreas] = useState<IBaseItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedBodyArea, setSelectedBodyArea] = useState<number>(0);

  const intl = useIntl();

  useEffect(() => {
    (async () => {
      const getResponse = await BodyAreaServices.GetBodyAreas();

      setBodyAreas(getResponse);
      setIsLoading(false);
    })();
  }, []);

  const onControlChange = (e: any) => {
    setSelectedBodyArea(parseInt(e.target.value));

    if (props.SuscribedChange) props.SuscribedChange(parseInt(e.target.value));
  };

  return (
    <>
      <Form.Group
        className={`justify-content-center ${props.ClassGroup || ""}`}
      >
        <Form.Label
          className={`font-label-form ${!props.Label ? "d-none" : ""}`}
        >
          <FormattedMessage id={props.Label} defaultMessage={props.Label} />
        </Form.Label>
        {isLoading ? (
          <></>
        ) : (
          <Form.Select
            size="sm"
            disabled={props.Disabled || false}
            onChange={(e: any) => onControlChange(e)}
            key={"select-body-area"}
            defaultValue={
              props.DefaultValue && bodyareas.length > 0
                ? props.DefaultValue
                : undefined
            }
          >
            {bodyareas?.map((element: IBaseItem, index: number) => {
              return (
                <option
                  value={element.Id}
                  key={`select-body-area-${element.Id}`}
                >
                  {element.Name}
                </option>
              );
            })}
          </Form.Select>
        )}
      </Form.Group>
    </>
  );
};

export default SelectBodyArea;
